import translate from '@data/translations';
import React from 'react';
import dayjs from 'dayjs';
import { HotelUserRole, TaskManagementItemModel, UserInfo } from '@common/modelDefinition';
import { getTaskTemplates, createOrUpdateTaskItem, deleteTaskItem } from './api';
import InlineModal from '@components/modalInline';
import { ReactComponent as Edit } from '../../assets/custom/icons/edit.svg';
import { ReactComponent as Delete } from '../../assets/custom/icons/trash.svg';
import { Filters, filterListItems, ListTableHeader, FilteredColumns } from '@components/TableContextMenuWraper';
import { CustomSelect, customStyles } from '@pages/dashboard/toolbar';
import { getTimeForTimePicker } from './controller';
import { RoomReservationStatusText } from './interfaces';
import PageTitle from '@components/pageTitle';
import useStore from '@data/state/zustand';
import ConfirmButtons from '@components/buttons/confirmButtons';
import PermissionCheck from '@components/PermissionCheck';
import TimePicker from '@components/timePicker';
import { orderBySimple } from '@components/orderByFunc';

export const taskTemplateObject: TaskManagementItemModel = {
    taskContent: '',
    taskStatus: null,
    taskGroup: 'cleaningTaskTemplate',
    parentId: null,
    userArguments: null,
    roomInfoId: null,
    reservationIds: null,
    customerId: null,
    companyId: null,
    taskManagementHeaderId: null,
    userCreated: null,
    userFinished: null,
    taskTitle: '',
    taskTimeEstimate: 0.25,
    userAssigned: null,
    inspectionFailedCount: 0,
    totalTaskDuration: 0,
    userSrcEncoded: 0,
    taskHistory: [],
    timestamp: new Date().getTime(),
    roomStatuses: null,
    severityEnum: 0,
};

const headers = [
    {
        filterKey: 'taskTitle',
        headerTitle: translate('Title'),
        label: 'taskTitle',
        type: '',
    },

    {
        filterKey: 'roomStatuses',
        headerTitle: translate('Room Status'),
        label: `roomStatuses`,
        type: 'reservationStatusBadge',
    },
];

interface TaskTemplateProps {
    history: any;
}
const TaskTemplates = (props: TaskTemplateProps) => {
    const { history } = props;
    const [taskTemplate, setTaskTemplate] = React.useState<TaskManagementItemModel | null>(null);
    const [filters, setFilters] = React.useState([] as Filters[]);
    const [sort, setSort] = React.useState({} as any);
    const [showContextMenu, setShowContextMenu] = React.useState(null as string | null);
    const [taskTemplates, setTaskTemplates] = React.useState<TaskManagementItemModel[]>([]);

    const loggedUser: UserInfo = useStore((appState: any) => appState.authTokenInfo?.user);

    React.useEffect(() => {
        const loadData = async () => {
            try {
                const _taskTemplates = await getTaskTemplates();
                setTaskTemplates(_taskTemplates);
            } catch (error: any) {}
        };

        loadData().catch((err) => {
            console.log(err);
        });
    }, []);

    let _taskTemplates = [...taskTemplates];

    if (sort) {
        for (const key in sort) {
            const val = sort[key];
            _taskTemplates = orderBySimple(_taskTemplates, key as keyof TaskManagementItemModel, val);
        }
    }
    const filteredTaskTemplates = filterListItems(_taskTemplates, filters);

    return (
        <div className="">
            <div className="title-with-options display-flex space-between">
                <PageTitle />
                <div className="page-title-button display-flex-mobile">
                    <PermissionCheck name="household_assigments">
                        <div
                            className="button-primary mr-16p"
                            onClick={() => {
                                const subTaskTemplate = { ...taskTemplateObject };
                                subTaskTemplate.taskGroup = 'cleaningTaskTemplate';
                                setTaskTemplate(subTaskTemplate);
                            }}
                        >
                            {translate('Add new task')}
                        </div>
                    </PermissionCheck>
                </div>
            </div>
            <InlineModal
                show={taskTemplate}
                header={translate(taskTemplate?.id ? taskTemplate?.taskTitle : 'New task template')}
                width="md"
                setShow={setTaskTemplate}
            >
                {taskTemplate ? (
                    <div className="">
                        <GeneralTab taskTemplate={taskTemplate} setTaskTemplate={setTaskTemplate} />
                        <br />
                        <ConfirmButtons
                            disableConfirm={
                                taskTemplate
                                    ? taskTemplate.taskTitle
                                        ? taskTemplate.taskTitle.length > 0
                                            ? false
                                            : true
                                        : true
                                    : true
                            }
                            onConfirm={async () => {
                                if (taskTemplate && taskTemplate.taskTitle) {
                                    await createOrUpdateTaskItem(taskTemplate);
                                    const _taskTemplates = await getTaskTemplates();

                                    setTaskTemplates(_taskTemplates);
                                    setTaskTemplate(null);
                                }
                            }}
                            onCancel={async () => {
                                setTaskTemplate(null);
                            }}
                            confirmText={'Save'}
                        />
                    </div>
                ) : null}
            </InlineModal>
            <div className="">
                <ListTableHeader
                    sort={sort}
                    setSort={setSort}
                    headers={headers}
                    listArray={taskTemplates}
                    showContextMenu={showContextMenu}
                    setShowContextMenu={setShowContextMenu}
                    filters={filters}
                    setFilters={setFilters}
                    setPage={() => {}}
                    history={history}
                >
                    <div></div>
                </ListTableHeader>
                {filteredTaskTemplates?.map((tt) => {
                    return (
                        <div id="no-hover" key={tt.id} className="custom-list-item">
                            <FilteredColumns headers={headers} listItem={tt} history={history} />
                            {loggedUser?.role !== HotelUserRole.maid && loggedUser?.role !== HotelUserRole.janitor ? (
                                <PermissionCheck name="household_assigments">
                                    <div className="display-flex">
                                        <div className="button-white-w-icon-only fill-red mr-8p">
                                            <Delete
                                                onClick={async () => {
                                                    if (tt.id) {
                                                        await deleteTaskItem(tt.id);
                                                        const _taskTemplates = await getTaskTemplates();
                                                        setTaskTemplates(_taskTemplates);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="button-white-w-icon-only mr-8p">
                                            <Edit
                                                onClick={() => {
                                                    const newTaskTemplate: TaskManagementItemModel = { ...tt };
                                                    if (newTaskTemplate.taskTimeEstimate === null) {
                                                        newTaskTemplate.taskTimeEstimate = 0.25;
                                                    }
                                                    setTaskTemplate(newTaskTemplate);
                                                }}
                                            />{' '}
                                        </div>
                                    </div>
                                </PermissionCheck>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    );
                })}
            </div>

            <div>
                <div></div>
            </div>
        </div>
    );
};

interface GeneralTabProps {
    taskTemplate: TaskManagementItemModel | null;
    setTaskTemplate: Function;
}

interface SelectOptions {
    label: string;
    value: string;
}
export enum TaskTypeText {
    'cleaningTaskTemplate' = 'Cleaning',
    'inspectionTaskTemplate' = 'Inspection',
}

export const GeneralTab = (props: GeneralTabProps) => {
    const { taskTemplate, setTaskTemplate } = props;
    const roomStatusOptions = ['arrival', 'dueOut', 'stay', 'emptyRoom']?.map((roomStatus: string) => {
        return {
            value: roomStatus,
            label: translate(RoomReservationStatusText[roomStatus as keyof typeof RoomReservationStatusText]),
        };
    });

    const roomStatusValues: SelectOptions[] = [];
    const taskTemplateParams = taskTemplate?.roomStatuses?.split(';');
    taskTemplateParams?.forEach((roomStatus: string) => {
        const newValue = {
            value: roomStatus,
            label: translate(RoomReservationStatusText[roomStatus as keyof typeof RoomReservationStatusText]),
        };
        roomStatusValues.push(newValue);
    });

    const typeOptions = ['cleaningTaskTemplate', 'inspectionTaskTemplate']?.map((t) => {
        return {
            value: t,
            label: translate(TaskTypeText[t as keyof typeof TaskTypeText]),
        };
    });

    return (
        <div className="">
            <div className="mr-8p">
                <label>
                    <b>{translate('Title')}</b>
                </label>
                <input
                    type="text"
                    onChange={(e) => {
                        if (taskTemplate) {
                            const newTaskTemplate: TaskManagementItemModel = { ...taskTemplate };
                            newTaskTemplate.taskTitle = e.target.value;
                            setTaskTemplate(newTaskTemplate);
                        }
                    }}
                    value={taskTemplate?.taskTitle ? taskTemplate.taskTitle : ''}
                    className="form-control"
                />
            </div>
            <div className="mr-12p mt-8p">
                <label>
                    <b>{translate('Type')}</b>
                </label>
                <CustomSelect
                    placeholder={translate('Type')}
                    styles={customStyles}
                    options={typeOptions}
                    onChange={(values: any) => {
                        if (values === null) {
                            const newTaskTemplate = { ...taskTemplate };
                            newTaskTemplate.taskGroup = '';
                            setTaskTemplate(newTaskTemplate);
                        } else {
                            const newTaskTemplate = { ...taskTemplate };

                            newTaskTemplate.taskGroup = values[values.length - 1].value;
                            setTaskTemplate(newTaskTemplate);
                        }
                    }}
                    value={
                        taskTemplate?.taskGroup !== ''
                            ? [
                                  {
                                      value: taskTemplate?.taskGroup,
                                      label: translate(
                                          TaskTypeText[taskTemplate?.taskGroup as keyof typeof TaskTypeText]
                                      ),
                                  },
                              ]
                            : []
                    }
                    width={'40%'}
                ></CustomSelect>
            </div>
            <div className="mr-8p mt-12p">
                <label>
                    <b className="mr-4p">{translate('Room status')}</b>-
                    <span className="ml-4p">{translate('multiple')}</span>
                </label>
                <div className="">
                    <CustomSelect
                        width="auto"
                        isMulti
                        placeholder={translate('By room status')}
                        styles={customStyles}
                        options={roomStatusOptions}
                        onChange={(values: any) => {
                            if (values === null) {
                                const newTaskTemplate = { ...taskTemplate };
                                newTaskTemplate.roomStatuses = null;
                                setTaskTemplate(newTaskTemplate);
                            } else {
                                const newTaskTemplate = { ...taskTemplate };
                                const newParams: string[] = [];
                                for (const value of values) {
                                    newParams.push(value.value);
                                }
                                newTaskTemplate.roomStatuses = newParams.join(';');
                                setTaskTemplate(newTaskTemplate);
                            }
                        }}
                        value={roomStatusValues}
                    ></CustomSelect>
                </div>
            </div>
            <div className="mr-8p mt-12p">
                <label>
                    <b>{translate('Task estimated time')}</b>
                </label>
                <div>
                    {' '}
                    <TimePicker
                        value={dayjs(
                            getTimeForTimePicker(taskTemplate?.taskTimeEstimate ? taskTemplate.taskTimeEstimate : 0.25)
                        )}
                        onChange={(e) => {
                            if (taskTemplate && e) {
                                const time = dayjs(e.valueOf()).format('HH:mm');
                                const timeArr = time.split(':');
                                const hour = Number(timeArr[0]);
                                const minutes = Number(timeArr[1]);

                                // Izračunajte ukupno vrijeme u satima
                                var _taskTimeEstimate = hour + minutes / 60;
                                const newTaskTemplate = { ...taskTemplate };
                                newTaskTemplate.taskTimeEstimate = _taskTimeEstimate;
                                setTaskTemplate(newTaskTemplate);
                            }
                        }}
                        minuteStep={1}
                    />
                </div>
            </div>
        </div>
    );
};
export default TaskTemplates;
